import { Country } from '@/src/types/apps/resto365Countries'
import { sessionCountry } from '@/src/@core/lib/session'

/**
 * Resolves the ask-gyg iframe URL for the current session country. The
 * deployment picks which countries are served by setting the matching `_AU` /
 * `_US` env var; an empty result means the feature isn't available.
 */
export function getAskGygUrl(country: Country = sessionCountry): string {
  switch (country) {
    case Country.AUS:
      return process.env.NEXT_PUBLIC_ASK_GYG_URL_AU || ''
    case Country.USA:
      return process.env.NEXT_PUBLIC_ASK_GYG_URL_US || ''
    default:
      return ''
  }
}
